import React from 'react'
import '../style/Footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
        <p>Copyright &copy; Knights From the Kingdom | A Lue Site</p>
    </footer>
  )
}

export default Footer